import React from 'react'
import { useDispatch } from 'react-redux'

import { isZipFile } from 'helpers'
import * as fromActions from 'store/actions/externalCourses.action'
import { ExternalCourseParticipantsListPayload } from 'store/actions/externalCourseParticipant.action'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { ExternalCourseModelAPI } from 'models/externalCourse.model'
import UploadFile from 'components/ui/modals/UploadFile'
import { Help } from '../../externalCourses/components/common'

export interface UploadCertificatesModalProps {
  show: boolean
  onClose?(): void
  externalCourse: ExternalCourseModelAPI
  participantList?: ExternalCourseParticipantsListPayload
}

export const UploadCertificatesModal: React.FC<UploadCertificatesModalProps> =
  ({ show, onClose, externalCourse, participantList }) => {
    const [error, setError] = React.useState<React.ReactNode>(null)
    const tUpload = useTranslationRankmi({
      prefix: 'administration.externalCourses.list.uploadCertificates',
    })
    const dispatch = useDispatch()

    const handleClose = () => {
      setError(null)
      onClose?.()
    }

    const handleFileUpload = (file: File) => {
      setError(null)
      if (!isZipFile(file)) {
        setTimeout(() => {
          setError(<>{tUpload('modal.error')}</>)
        }, 500)
        return
      }
      dispatch(
        fromActions.Actions.uploadCertificates({
          id: externalCourse.id,
          file,
          participantList,
        })
      )
      handleClose()
    }

    return (
      <>
        <UploadFile
          show={show}
          title={tUpload('modal.title')}
          labels={{
            legend: tUpload('modal.legend'),
            addFile: tUpload('modal.addFile'),
          }}
          template={{
            link: 'https://rankmi-lms-prod.s3.amazonaws.com/templates/certificados.zip',
            label: tUpload('modal.template'),
          }}
          onClose={() => {
            handleClose()
          }}
          onUpload={handleFileUpload}
          help={<Help />}
          error={error}
        />
      </>
    )
  }

export default UploadCertificatesModal
